module.exports = __webpack_public_path__ + "img/pp.b1807e33.svg";